const API_BASE_URL = 'http://202.137.117.84:8019/'

export default API_BASE_URL 